import { render, staticRenderFns } from "./change-display.vue?vue&type=template&id=504f0573&scoped=true&"
import script from "./change-display.vue?vue&type=script&lang=ts&"
export * from "./change-display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f0573",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504f0573')) {
      api.createRecord('504f0573', component.options)
    } else {
      api.reload('504f0573', component.options)
    }
    module.hot.accept("./change-display.vue?vue&type=template&id=504f0573&scoped=true&", function () {
      api.rerender('504f0573', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/change-display.vue"
export default component.exports